// axios client
import client from './client';





// =========================
// 댓글 조회
// =========================

export const getComments = async (

    postId: number
) => {

    // API 요청
    const response = await client.get(

        `/comments/${postId}`
    );





    return response.data;
};





// =========================
// 댓글 작성
// =========================

export const createComment = async (

    postId: number,

    content: string
) => {

    // API 요청
    const response = await client.post(

        '/comments',

        {

            postId,

            content
        }
    );





    return response.data;
};





// =========================
// 댓글 삭제
// =========================

export const deleteComment = async (

    commentId: number
) => {

    // API 요청
    const response = await client.delete(

        `/comments/${commentId}`
    );





    return response.data;
};